import './queensAward.scss';
import * as React from 'react';
import useQueensAward from '../../hooks/staticQueries/home/useQueensAward';
import { LazyCosmosImage } from '../media/cosmosImage';
export const QueensAward = () => {
    const { page } = useQueensAward();
    return (<div className="queens-award">
      {page.queens_award.header && <LazyCosmosImage ticket={page.queens_award.icon[0].ticket} alt="queens award"/>}
      <div>
        {page.queens_award.header && (<p>
            <strong>{page.queens_award.header}</strong>
          </p>)}
        {page.queens_award.copy && <p>{page.queens_award.copy}</p>}
      </div>
    </div>);
};
